import React, { Component } from "react";
import config from "react-global-configuration";
import axios from "axios";
import $ from "jquery";
import Select from "react-select";
import jwt_decode from "jwt-decode";
import { style } from "variables/Variables.jsx";
import "../../assets/css/react-confirm-alert/react-confirm-alert.css";
import NotificationSystem from "react-notification-system";
import { confirmAlert } from "react-confirm-alert";
import { BeatLoader } from "react-spinners";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { css } from "@emotion/core";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import * as moment from "moment";
import DatePicker from "react-datepicker";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { List } from "react-virtualized";
import { isApiResponse, isReportAccess, user_activities, reactSelectStyles, date_range_config } from '../../helpers/utils.js';
import StateFilter from '../../filters/StateFilter.jsx';
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

class EditLeaComplaint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      loading: false,
      complaintId: null,
      isAutoPopulating: false,

      // Manual Input Fields (Section 1)
      date_of_receipt: moment(new Date()).format("YYYY-MM-DD"),
      ticket_number: "",
      lea_case_number: "",
      link_id: "",
      notice_details: "",
      complainant_name: "",
      complainant_card_upi_number: "",

      // Auto-populated fields (Section 2 - Merchant Details)
      merchant_mobile_number: "",
      merchant_name: "",
      merchant_city: "",
      merchant_state: "",
      date_of_mobile_registration: "",
      geo_location_onboarding: "",
      pkyc_date: "",
      transaction_amount: "",
      transaction_rrn: "",
      geo_location_transaction: "",
      bank_account_number: "",
      bank_name: "",
      branch_location: "",
      card_issuer_upi_bank: "",
      geo_location_complainant: "",

      // Additional Information (Section 3)
      sender_email_id: "",
      date_of_disputed_transaction: moment(new Date()).format("YYYY-MM-DD"),
      date_of_email: moment(new Date()).format("YYYY-MM-DD"),
      date_of_response: moment(new Date()).format("YYYY-MM-DD"),
      customer_details: "",
      remarks: "",
      acknowledgement_number: "",
      lea_authority_state:'',
      lea_authority:'',
      lea_authority_city:''
    };
  }

  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift" />,
      message: <div>{msg}</div>,
      level: level,
      position: position,
      autoDismiss: 5,
    });
  };

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });

    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    this.setState({ email: decoded.email });

    const tokenPermission = localStorage.userPermission;
    const decoded_permission = jwt_decode(tokenPermission);
    let AllAccessPermissions = decoded_permission.accessPermissions;
    isReportAccess(AllAccessPermissions, "LEA_complaint_report");

    // Get complaint ID from URL params
    const complaintId = this.props.match.params.id;
    this.setState({ complaintId });

    // Load existing complaint data
    this.loadComplaintData(complaintId);
  }

  loadComplaintData(id) {
    this.setState({ loading: true });

    axios
      .get(
        config.get("API_URL") + `/CrispReport/get_lea_complaint/${id}`,
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status === 'success') {
          const data = response.data.data;
          this.setState({
            date_of_receipt: data.date_of_receipt ? moment(data.date_of_receipt).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
            ticket_number: data.ticket_number || "",
            lea_case_number: data.lea_case_number || "",
            link_id: data.link_id || "",
            notice_details: data.notice_details || "",
            complainant_name: data.complainant_name || "",
            complainant_card_upi_number: data.complainant_card_upi_number || "",

            // Merchant Details
            merchant_mobile_number: data.merchant_mobile_number || "",
            merchant_name: data.merchant_name || "",
            merchant_city: data.merchant_city || "",
            merchant_state: data.merchant_state || "",
            date_of_mobile_registration: data.mobile_registration_date || data.date_of_mobile_registration || "",
            geo_location_onboarding: data.geo_location_onboarding || "",
            pkyc_date: data.pkyc_date ? moment(data.pkyc_date).format("YYYY-MM-DD") : "",
            transaction_amount: data.transaction_amount || "",
            transaction_rrn: data.transaction_rrn || "",
            geo_location_transaction: data.geo_location_transaction || "",
            bank_account_number: data.bank_account_number || "",
            bank_name: data.bank_name || "",
            branch_location: data.branch_location || "",
            card_issuer_upi_bank: data.card_issuer_upi_bank || "",
            geo_location_complainant: data.geo_location_complainant || "",

            // Additional Information
            sender_email_id: data.sender_email_id || "",
            date_of_disputed_transaction: data.date_of_disputed_transaction ? moment(data.date_of_disputed_transaction).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
            date_of_email: data.date_of_email ? moment(data.date_of_email).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
            date_of_response: data.date_of_response ? moment(data.date_of_response).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
            customer_details: data.customer_details || "",
            remarks: data.remarks || "",
            acknowledgement_number: data.acknowledgement_number || "",
            lea_authority_state: data.lea_authority_state || "",
            lea_authority_city: data.lea_authority_city || "",
            lea_authority: data.lea_authority || "",
            loading: false,
            selected_state: { value: data.lea_authority_state, label: data.lea_authority_state },
          });
        } else {
          this.handleNotificationClick("tr", 3, response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.handleNotificationClick("tr", 3, "Error loading complaint data");
        this.setState({ loading: false });
      });
  }

  onChangeInput(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  // Auto-populate fields based on Link ID
  fetchMerchantDetails = async (linkId) => {
    if (!linkId || linkId.trim() === "") {
      return;
    }

    this.setState({ isAutoPopulating: true });

    try {
      const response = await axios.post(
        `${config.get("API_URL")}/CrispReport/get_merchant_details_by_link_id`,
        { link_id: linkId },
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        }
      );

      if (response.data.status === 'success' && response.data.data) {
        const merchantData = response.data.data[0];

        this.setState({
          merchant_mobile_number: merchantData.merchant_mobile_number || "",
          merchant_name: merchantData.merchant_name || "",
          merchant_city: merchantData.merchant_city || "",
          merchant_state: merchantData.merchant_state || "",
          date_of_mobile_registration: merchantData.date_of_mobile_registration || "",
          geo_location_onboarding: merchantData.geo_location_onboarding || "",
          pkyc_date: merchantData.pkyc_date || "",
          transaction_amount: merchantData.transaction_amount || "",
          transaction_rrn: merchantData.transaction_rrn || "",
          geo_location_transaction: merchantData.geo_location_transaction || "",
          bank_account_number: merchantData.bank_account_number || "",
          bank_name: merchantData.bank_name || "",
          branch_location: merchantData.branch_location || "",
          card_issuer_upi_bank: merchantData.card_issuer_upi_bank || "",
          geo_location_complainant: merchantData.geo_location_complainant || "",
          date_of_disputed_transaction: merchantData.transaction_date
            ? moment(merchantData.transaction_date).format("YYYY-MM-DD")
            : this.state.date_of_disputed_transaction
        });

        this.handleNotificationClick("tr", 1, "Merchant details auto-populated successfully");
      } else {
        this.handleNotificationClick("tr", 2, "No merchant data found for this Link ID");
      }
    } catch (error) {
      console.error("Error fetching merchant details:", error);
      this.handleNotificationClick("tr", 3, "Error fetching merchant details");
    } finally {
      this.setState({ isAutoPopulating: false });
    }
  };

  // Handle Link ID change and trigger auto-population
  onLinkIdChange = (e) => {
    const linkId = e.target.value;
    this.setState({ link_id: linkId });

    // Debounce the API call
    if (this.linkIdTimeout) {
      clearTimeout(this.linkIdTimeout);
    }

    if (linkId.length >= 18 && linkId.startsWith('INNOV')) {
        this.linkIdTimeout = setTimeout(() => {
          this.fetchMerchantDetails(linkId);
        }, 300);
      }
  };

  update_complaint() {
    if (this.state.ticket_number == "") {
      this.handleNotificationClick("tr", 3, "Please Enter Ticket Number");
      return false;
    }
    if (this.state.lea_case_number == "") {
      this.handleNotificationClick("tr", 3, "Please Enter LEA Case Number");
      return false;
    }
    if (this.state.link_id == "") {
      this.handleNotificationClick("tr", 3, "Please Enter Link ID");
      return false;
    }

    this.setState({ loading: true });

    var data = {
      date_of_receipt: this.state.date_of_receipt,
      sender_email_id: this.state.sender_email_id,
      merchant_state: this.state.merchant_state,
      ticket_number: this.state.ticket_number,
      acknowledgement_number: this.state.acknowledgement_number,
      notice_details: this.state.notice_details,
      transaction_amount: this.state.transaction_amount,
      merchant_mobile_number: this.state.merchant_mobile_number,
      merchant_name: this.state.merchant_name,
      date_of_disputed_transaction: this.state.date_of_disputed_transaction,
      transaction_rrn: this.state.transaction_rrn,
      card_issuer_upi_bank: this.state.card_issuer_upi_bank,
      date_of_email: this.state.date_of_email,
      date_of_response: this.state.date_of_response,
      customer_details: this.state.customer_details,
      remarks: this.state.remarks,
      lea_case_number: this.state.lea_case_number,
      merchant_city: this.state.merchant_city,
      mobile_registration_date: this.state.date_of_mobile_registration,
      geo_location_onboarding: this.state.geo_location_onboarding,
      pkyc_date: this.state.pkyc_date,
      link_id: this.state.link_id,
      geo_location_transaction: this.state.geo_location_transaction,
      bank_account_number: this.state.bank_account_number,
      bank_name: this.state.bank_name,
      branch_location: this.state.branch_location,
      complainant_name: this.state.complainant_name,
      complainant_card_upi_number: this.state.complainant_card_upi_number,
      geo_location_complainant: this.state.geo_location_complainant,
      updated_by: this.state.email,
      lea_authority: this.state.lea_authority,
      lea_authority_city: this.state.lea_authority_city,
      lea_authority_state: this.state.lea_authority_state
    };

    axios
      .put(
        config.get("API_URL") + `/CrispReport/update_lea_complaint/${this.state.complaintId}`,
        data,
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        }
      )
      .then((response) => {
        this.setState({ loading: false });
        console.log(response.data)
        if (response.data.status == 'error') {
          this.handleNotificationClick("tr", 3, response.data.message);
        } else {
          this.handleNotificationClick("tr", 1, response.data.message);
          setTimeout(() => {
            this.redirect_to_list();
          }, 200);
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  redirect_to_list(e) {
    const { history } = this.props;
    history.push("/admin/lea-complaint-report");
  }

  handleDateOfReceiptChange = (date) => {
    var date_of_receipt = moment(date).format("YYYY-MM-DD");
    this.setState({ date_of_receipt: date_of_receipt });
  };

  handleDisputedTransactionDateChange = (date) => {
    var date_of_disputed_transaction = moment(date).format("YYYY-MM-DD");
    this.setState({ date_of_disputed_transaction: date_of_disputed_transaction });
  };

  handleEmailDateChange = (date) => {
    var date_of_email = moment(date).format("YYYY-MM-DD");
    this.setState({ date_of_email: date_of_email });
  };

  handleResponseDateChange = (date) => {
    var date_of_response = moment(date).format("YYYY-MM-DD");
    this.setState({ date_of_response: date_of_response });
  };
    goBack = () => {
        this.props.history.push('/admin/LEA-complaint-report')
      }

   handleState = (State) =>{
        const value = State === null ? '' : State.value;
        this.setState({
            isChange: true,
            lea_authority_state:value,
        })
    }
  render() {
    if (this.state.loading) {
      return (
        <div className="content">
          <div className="text-center" style={{ paddingTop: "100px" }}>
            <BeatLoader
              css={override}
              size={15}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />
          </div>
        </div>
      );
    }

    return (
      <div className="content">
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 pt-5">
              <div className="">
                <div className="content">
                  <div className="row">
                    <div className="card title-card-bottom-space">
                        <div className="col-xs-9 padd-5">
                            <div className="header">
                              <h4 className="title">Edit LEA Complaint</h4>
                              <p className="category"></p>
                            </div>
                        </div>
                      <div className="col-md-3 pull-right">
                        <div className="r-p-menu">
                           <button type="button" className="primary reset-filter" role="button"  onClick={this.goBack}><i class="fa fa-arrow-circle-left"></i>Back</button>

                        </div>

                    </div>
                    <div className="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div className="content">
                  <div className="row">
                    <div className="col-lg-12 padd-5">
                      <div className="card add-camp-con">
                        <div className="content">
                          <div className="row">

                            {/* Section 1: Basic Information (Manual Input) */}
                            <div>
                              <div className="col-md-12">
                                <h5 style={{color: '#666', marginBottom: '20px'}}>
                                  Basic Information
                                </h5>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Date of Receipt <span style={{color: 'red'}}>*</span></label>
                                  <DatePicker
                                    dateFormat="d MMM yyyy"
                                    selected={Date.parse(this.state.date_of_receipt)}
                                    onChange={this.handleDateOfReceiptChange}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Ticket Number <span style={{color: 'red'}}>*</span></label>
                                  <Input
                                    id="ticket_number"
                                    name="ticket_number"
                                    value={this.state.ticket_number}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter ticket number assigned by Innoviti"
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>LEA Case Number <span style={{color: 'red'}}>*</span></label>
                                  <Input
                                    id="lea_case_number"
                                    name="lea_case_number"
                                    value={this.state.lea_case_number}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter LEA case number"
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            {/* Link ID (Priority Field) */}
                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Link ID <span style={{color: 'red'}}>*</span></label>
                                  <Input
                                    id="link_id"
                                    name="link_id"
                                    value={this.state.link_id}
                                    onChange={this.onLinkIdChange}
                                    placeholder="Enter Link ID "
                                  />
                                  {this.state.isAutoPopulating && (
                                    <small style={{color: 'blue'}}>
                                      <BeatLoader size={8} color="#007bff" loading={true} />
                                      {' '}Fetching merchant details...
                                    </small>
                                  )}
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Notice Details</label>
                                  <textarea
                                    name="notice_details"
                                    rows="4"
                                    id="notice_details"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.notice_details}
                                    placeholder="Enter notice details"
                                  ></textarea>
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Complainant Name</label>
                                  <Input
                                    id="complainant_name"
                                    name="complainant_name"
                                    value={this.state.complainant_name}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter complainant name"
                                  />
                                </div>
                                <div className="clearfix"></div>

                                <div className="form-group">
                                  <label>Complainant Card/UPI Number</label>
                                  <Input
                                    id="complainant_card_upi_number"
                                    name="complainant_card_upi_number"
                                    value={this.state.complainant_card_upi_number}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter complainant card/UPI number"
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                              <div className="col-md-4 ">
                                  <div className="form-group">
                                <label> LEA Authority State: </label>
                                <StateFilter ref="stateFilter" onSelectstate = {this.handleState} selected_state={this.state.selected_state}/>
                                </div>
                                <div className="clearfix"></div>
                             </div>
                             <div className="col-md-4">
                                <div className="form-group">
                                  <label>LEA Authority City <span style={{color: 'red'}}></span></label>
                                  <Input
                                    id="lea_authority_city"
                                    name="lea_authority_city"
                                    value={this.state.lea_authority_city}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter LEA Authority City"
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>LEA Authority <span style={{color: 'red'}}></span></label>
                                  <Input
                                    id="lea_authority"
                                    name="lea_authority"
                                    value={this.state.lea_authority}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter LEA Authority"
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                            </div>

                            {/* Section 2: Auto-populated Merchant Details */}
                            <div>
                              <div className="col-md-12">
                                <h5 style={{color: '#666', marginBottom: '20px', marginTop: '30px'}}>
                                  Merchant Details
{/*                                   <small style={{fontSize: '12px'}}> (These fields will be filled automatically based on Link ID)</small> */}
                                </h5>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Merchant Mobile Number</label>
                                  <Input
                                    id="merchant_mobile_number"
                                    name="merchant_mobile_number"
                                    value={this.state.merchant_mobile_number}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Merchant Name</label>
                                  <Input
                                    id="merchant_name"
                                    name="merchant_name"
                                    value={this.state.merchant_name}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Merchant City</label>
                                  <Input
                                    id="merchant_city"
                                    name="merchant_city"
                                    value={this.state.merchant_city}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Merchant State</label>
                                  <Input
                                    id="merchant_state"
                                    name="merchant_state"
                                    value={this.state.merchant_state}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Date of Mobile Registration</label>
                                  <Input
                                    id="date_of_mobile_registration"
                                    name="date_of_mobile_registration"
                                    value={this.state.date_of_mobile_registration}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Geo Location Onboarding</label>
                                  <Input
                                    id="geo_location_onboarding"
                                    name="geo_location_onboarding"
                                    value={this.state.geo_location_onboarding}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>PKYC Date</label>
                                  <Input
                                    id="pkyc_date"
                                    name="pkyc_date"
                                    value={this.state.pkyc_date}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Transaction Amount</label>
                                  <Input
                                    id="transaction_amount"
                                    name="transaction_amount"
                                    value={this.state.transaction_amount}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Transaction RRN</label>
                                  <Input
                                    id="transaction_rrn"
                                    name="transaction_rrn"
                                    value={this.state.transaction_rrn}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Geo Location Transaction</label>
                                  <Input
                                    id="geo_location_transaction"
                                    name="geo_location_transaction"
                                    value={this.state.geo_location_transaction}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Bank Account Number</label>
                                  <Input
                                    id="bank_account_number"
                                    name="bank_account_number"
                                    value={this.state.bank_account_number}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Bank Name</label>
                                  <Input
                                    id="bank_name"
                                    name="bank_name"
                                    value={this.state.bank_name}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Branch Location</label>
                                  <Input
                                    id="branch_location"
                                    name="branch_location"
                                    value={this.state.branch_location}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Card Issuer UPI Bank</label>
                                  <Input
                                    id="card_issuer_upi_bank"
                                    name="card_issuer_upi_bank"
                                    value={this.state.card_issuer_upi_bank}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Geo Location Complainant</label>
                                  <Input
                                    id="geo_location_complainant"
                                    name="geo_location_complainant"
                                    value={this.state.geo_location_complainant}
                                    onChange={this.onChangeInput.bind(this)}
                                    style={{backgroundColor: '#f8f9fa'}}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            {/* Section 3: Additional Information (Manual Input) */}
                            <div>
                              <div className="col-md-12">
                                <h5 style={{color: '#666', marginBottom: '20px', marginTop: '30px'}}>
                                  Additional Information
                                </h5>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Date of Disputed Transaction</label>
                                  <DatePicker
                                    dateFormat="d MMM yyyy"
                                    selected={Date.parse(this.state.date_of_disputed_transaction)}
                                    onChange={this.handleDisputedTransactionDateChange}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Date of Email</label>
                                  <DatePicker
                                    dateFormat="d MMM yyyy"
                                    selected={Date.parse(this.state.date_of_email)}
                                    onChange={this.handleEmailDateChange}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Date of Response</label>
                                  <DatePicker
                                    dateFormat="d MMM yyyy"
                                    selected={Date.parse(this.state.date_of_response)}
                                    onChange={this.handleResponseDateChange}
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            <div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Sender Email ID</label>
                                  <Input
                                    id="sender_email_id"
                                    name="sender_email_id"
                                    value={this.state.sender_email_id}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter sender email ID"
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Acknowledgement Number</label>
                                  <Input
                                    id="acknowledgement_number"
                                    name="acknowledgement_number"
                                    value={this.state.acknowledgement_number}
                                    onChange={this.onChangeInput.bind(this)}
                                    placeholder="Enter Acknowledgement number"
                                  />
                                </div>
                                <div className="clearfix"></div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Customer Details</label>
                                  <textarea
                                    name="customer_details"
                                    rows="4"
                                    id="customer_details"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.customer_details}
                                    placeholder="Enter customer details"
                                  ></textarea>
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            <div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>Remarks</label>
                                  <textarea
                                    name="remarks"
                                    rows="4"
                                    id="remarks"
                                    onChange={this.onChangeInput.bind(this)}
                                    className="form-control pricingDescription"
                                    value={this.state.remarks}
                                    placeholder="Enter any additional remarks"
                                  ></textarea>
                                </div>
                                <div className="clearfix"></div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                            {/* Submit Button */}
                            <div>
                              <div className="col-md-12" style={{marginTop: '30px'}}>
                                <div className="form-group">
                                  <button
                                    className="campaignButton"
                                    role="button"
                                    onClick={this.update_complaint.bind(this)}
                                    disabled={this.state.isAutoPopulating || this.state.loading}
                                    style={{
                                      marginRight: '10px',
                                      opacity: (this.state.isAutoPopulating || this.state.loading) ? 0.6 : 1
                                    }}
                                  >
                                    {this.state.loading ? 'Updating...' : (this.state.isAutoPopulating ? 'Processing...' : 'Update Complaint')}
                                  </button>

                                  <button
                                    className="btn btn-secondary"
                                    role="button"
                                    onClick={this.redirect_to_list.bind(this)}
                                    disabled={this.state.isAutoPopulating || this.state.loading}
                                    style={{
                                      opacity: (this.state.isAutoPopulating || this.state.loading) ? 0.6 : 1
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                              <div className="clearfix"></div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditLeaComplaint;